import React, { useEffect } from "react";
import { Button, Form, message, Spin } from "antd";
import { useNavigate } from "react-router";
import dayjs from "dayjs";
import {
  useDonationTableGet,
  useDonationCreate,
  useDonationUpdate,
} from "../../../hooks/api/donations";
import SinglePageContainer from "../../Common/SinglePageContainer";
import TopDonorForm from "./Form";

export default function TopDonorContent() {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const donationTableGet = useDonationTableGet();
  const donationCreate = useDonationCreate();
  const donationUpdate = useDonationUpdate();

  useEffect(() => {
    donationTableGet.fetch({ page: 1, pageSize: 1 });
  }, []);

  useEffect(() => {
    if (!donationTableGet.data) return;

    const donations = donationTableGet.data.data || [];
    if (donations.length === 0) return;

    const donor = donations[0];

    if (!donor) return;

    form.setFieldsValue({
      name: donor.name || "",
      description: donor.description || "",
      startDate: donor.startDate ? dayjs(donor.startDate) : null,
      endDate: donor.endDate ? dayjs(donor.endDate) : null,
    });
  }, [donationTableGet.data, form]);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const payload = {
        name: values.name,
        description: values.description,

        startDate: values.startDate
          ? dayjs(values.startDate).format("YYYY-MM-DD")
          : null,
        endDate: values.endDate
          ? dayjs(values.endDate).format("YYYY-MM-DD")
          : null,
      };

      const donations = donationTableGet.data?.data || [];
      const existingDonor = donations[0];
      let result;

      if (existingDonor?.id) {
        result = await donationUpdate.fetch(payload, existingDonor.id);
      } else {
        result = await donationCreate.fetch(payload);
      }

      if (result instanceof Error || (result as any)?.isAxiosError) {
        throw result;
      }

      message.success(
        existingDonor
          ? "Top Donor updated successfully"
          : "Top Donor added successfully",
      );
    } catch (error) {
      message.error("Failed to save Top Donor");
      console.error(error);
    }
  };

  return (
    <SinglePageContainer
      title="Donations"
      cardLoading={donationTableGet.loading}
      style={{ maxWidth: 520 }}
    >
      <>
        <TopDonorForm form={form} />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 8,
          }}
        >
          <Button type="primary" ghost onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={donationCreate.loading || donationUpdate.loading}
          >
            Save
          </Button>
        </div>
      </>
    </SinglePageContainer>
  );
}
